import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { leadListsApi } from "../../../libs/landvoice-api";
import { LeadList } from "../../../types/neighborhoodSearch";
import { getNsSavedSearchCacheKey, NS_LIST_SAVED_SEARCHES_CACHE_KEY, NS_UPDATE_SAVED_SEARCH_MUTATION_KEY } from "../constants/cacheKeys";

export const useUpdateSavedSearchMutation = (): UseMutationResult<
  LeadList,
  Error,
  { listId: string; leadList: LeadList }
> => {
  const queryClient = useQueryClient();
  return useMutation<LeadList, Error, { listId: string; leadList: LeadList }>({
    mutationKey: [NS_UPDATE_SAVED_SEARCH_MUTATION_KEY],
    mutationFn: async ({
      listId,
      leadList,
    }: {
      listId: string;
      leadList: LeadList;
    }) => {
      const response = await leadListsApi.updateList(listId, leadList);
      return response.data;
    },
    onSuccess: (_, { listId }) => {
      queryClient.invalidateQueries({
        queryKey: getNsSavedSearchCacheKey(listId),
      });
      queryClient.invalidateQueries({
        queryKey: [NS_LIST_SAVED_SEARCHES_CACHE_KEY],
      });
    },
  });
};